var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-spinner"},[_c('div',{staticClass:"dots"},_vm._l((3),function(n){return _c('span',{key:n,style:({ backgroundColor: _vm.color })})}),0),(_vm.hasMessage)?_c('div',{staticClass:"text"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }